import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Shared Firebase Auth pool for the squint-de-{env} project — config is
// per-env, injected at build time. authDomain must be listed in the
// project's authorized domains (platform terraform manages that list).
const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
});

export const auth = getAuth(app);
